var ELEMENT_VDW_RADII = {
    "H": 1.2,
    "Li": 1.82,
    "Na": 2.27,
    "K": 2.75,
    "C": 1.7,
    "N": 1.55,
    "O": 1.52,
    "F": 1.47,
    "P": 1.80,
    "S": 1.80,
    "Cl": 1.75,
    "Br": 1.85,
    "Se": 1.90,
    "Zn": 1.39,
    "Cu": 1.4,
    "Ni": 1.63
}

exports.ELEMENT_VDW_RADII = ELEMENT_VDW_RADII